import React from 'react';
import deepal from '../../assets/Deepal-Shah.jpg';
import vidhi from '../../assets/Vidhi_Shah.jpg';

const founders = [
  {
    name: 'Deepal Shah',
    image: deepal,
    title: 'Co-Founder & Financial Strategist',
    bio: `Coming from a solid background in finance and securities, Deepal Shah brings a strategic and structured approach to BlueLagoon Travels. His expertise in managing complex processes and navigating the financial world adds a layer of security and reliability to the business. Deepal’s experience ensures that all aspects of your travel are meticulously planned, with a focus on delivering top-quality service. His shared passion for travel, alongside Vidhi, was the driving force behind the creation of BlueLagoon Travels five years ago.`,
  },
  {
    name: 'Vidhi Shah',
    image: vidhi,
    title: 'Co-Founder & Creative Visionary',
    bio: `Vidhi Shah’s passion for travel has been a lifelong journey. As a former homemaker, she explored many creative avenues, including choreography, baking, and organizing exhibitions. Her love for travel, however, remained constant, inspiring her to transform her personal passion into a professional venture. With an eye for detail and a deep understanding of creating memorable experiences, Vidhi brings her energy and creativity to every aspect of BlueLagoon Travels, ensuring that each journey is as unique and exciting as the traveler.`,
  },
];

const Founders = () => {
  return (
    <section className='py-10'>
      <div className='container mx-auto px-4 lg:px-16'>
        {/* Section Title */}
        <h2 className='mont mb-16 text-center text-4xl font-bold text-gray-900'>
          Meet Our Founders
        </h2>

        {/* Flex Row for Cards */}
        <div className='flex flex-col items-stretch justify-center gap-8 md:flex-row'>
          {founders.map((founder, idx) => (
            <div
              key={idx}
              className='flex flex-col rounded-lg bg-[#EFFFF8] p-8 transition-shadow duration-500 md:w-1/2'
            >
              <div className='flex items-start gap-6'>
                {/* Left: Small circular image */}
                <div className='flex-shrink-0'>
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className='h-24 w-24 rounded-full object-cover'
                  />
                </div>

                {/* Right: Content */}
                <div>
                  <h3 className='text-2xl font-bold text-gray-900'>{founder.name}</h3>
                  <p className='mt-1 font-semibold text-gray-700'>{founder.title}</p>
                </div>
              </div>
              <p className='mt-6 text-justify leading-relaxed text-gray-700'>{founder.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Founders;
